import cn from 'classnames';
import { useState, ChangeEvent } from 'react';
import Input from './Input';
import Button from '@components/button';
// import { useTrail, animated } from 'react-spring';

import chipSvg from '@assets/svg/chip.svg';
import chip2Svg from '@assets/svg/chip2.svg';

import styles from './CouponTab.module.scss';

const Coupon = (): JSX.Element => {
  // const windowWidth = useWindowWidth();
  const [coupon, setCoupon] = useState('');

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setCoupon(e.target.value);
  };

  const handleClaim = async (): Promise<void> => {
    console.log('claim coupon');
  };

  return (
    <div className={cn(styles.container)}>
      <img src={chipSvg} className={styles.chipLeft} />
      <img src={chip2Svg} className={styles.chipRight} />

      <section className={styles.content}>
        <div className={styles.heading}>Redeem a Coupon Code</div>

        <div className={styles.input}>
          <Input type='text' value={coupon} onChange={onChange} name='code' placeholder='Enter Coupon code...' />
        </div>

        <p className={styles.hint}>
          You may find a coupon code on our{' '}
          <a href='#' target='_blank'>
            Twitter
          </a>
        </p>

        <Button color='green' size='normal' radius='pill' className={styles.submit} onClick={handleClaim}>
          Claim
        </Button>
      </section>
    </div>
  );
};
export default Coupon;
